import React from 'react';
import classNames from 'classnames';
import './WidgetSettingsNumericValueEditor.scss';
import { NumericValueEditor } from '@instinet-analytics/semantic-ui-components';

export interface WidgetSettingsNumericValueEditorProps<
    TKey extends string,
    TConfig extends Record<TKey, number | undefined>,
> {
    className?: string;
    propertyName: TKey;
    config: TConfig;
    label: string;
    min?: number;
    max?: number;
    onChange: (delta: Partial<TConfig>) => void;
}

export default function WidgetSettingsNumericValueEditor<
    TKey extends string,
    TConfig extends Partial<Record<TKey, number | undefined>>,
>(props: WidgetSettingsNumericValueEditorProps<TKey, TConfig>) {
    const { config, onChange, propertyName, label, max, min, className } =
        props;

    const configValue = config[propertyName];

    const onChanged = (nextValue: number) => {
        const delta = {
            [propertyName]: nextValue,
        } as Partial<TConfig>;
        onChange(delta);
    };

    const cssClasses = classNames(
        'WidgetSettingsNumericValueEditor',
        className
    );

    return (
        <NumericValueEditor
            className={cssClasses}
            value={configValue ?? 0}
            label={label}
            max={max}
            min={min}
            onChange={onChanged}
        />
    );
}
